<template>

</template>
<script>

  import {get,forOwn} from 'lodash'

  export default {
    name: "entities-geojson-data-source",
    props:{
      cesiumId:{
        type:String,
        default:"default"
      },
      entities:{//объект должен быть иммутабелен
        type:Array,
        default: () => []
      },
      pathToGeoJson:{
        type:String,
        require:true
      },
    },
    data:()=>{
      return{
        geojsonDataSourcesByIdEntity:{}
      }
    },
    methods:{

    },
    watch:{
      entities:{//Должен быть иммутебельный
        immediate:true,
        handler(newEntities,oldEntities){

          const entitiesForAdd=newEntities.filter(newEntity=>!oldEntities.find(oldEntity=>isEqual(newEntity,oldEntity)))
          const entitiesForRemove=(oldEntities||[]).filter(oldEntity=>!newEntities.find(newEntity=>newEntity.id==oldEntity.id))

          const cesium = window.cesiumViewer[this.cesiumId];

          entitiesForRemove.forEach(entity=>cesium.viewer.dataSources.remove(this.geojsonDataSourcesByIdEntity[entity.id], false))

          entitiesForAdd.forEach(entity=>cesium.viewer.dataSources.add(Cesium.GeoJsonDataSource.load(JSON.parse(get(entity,this.pathToGeoJson)))).then(datasource=>{
            this.geojsonDataSourcesByIdEntity[entity.id]=datasource;
          }))

        }
      },
      cesiumId(newCesiumId){
        throw new Error("Deny change cesiumId");
      }
    },
    destroyed(){
      const cesium = window.cesiumViewer[this.cesiumId];
      forOwn(this.geojsonDataSourcesByIdEntity,(value,key)=>cesium.viewer.dataSources.remove(value, false))
    }
  }
</script>

<style scoped>

</style>
